import moment from 'moment';

export const DATE_FORMAT_DISPLAY = 'M/D/YYYY';
export const DATE_FORMAT_INPUT_DISPLAY = 'MM/DD/YYYY';
export const DATE_FORMAT_DISPLAY_FULL = 'MMMM D, YYYY';
export const DATE_FORMAT_DISPLAY_SELECTOR = 'ddd, MMM D';
export const DATE_FORMAT_DISPLAY_FULL_DATE = 'dddd, MMMM DD';
export const DATE_FORMAT_DISPLAY_FULL_TIME = 'MMMM D, YYYY hh:mm A z';
export const DATE_FORMAT_NEXT_AVAILABLE_DAY = 'ddd, MMM D'; //e.g. Wed, Sept 27
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT_DISPLAY = 'h:mm A';
export const TIME_FORMAT = 'HH:mm:ss';

export const ISO_FORMAT = `${DATE_FORMAT}T${TIME_FORMAT}`;

export function createTimeChoices(isoTimes) {
    return isoTimes.map(time => {
        const timeObj = moment(time, ISO_FORMAT);

        return {
            label: timeObj.format(TIME_FORMAT_DISPLAY),
            value: timeObj.format(TIME_FORMAT),
        };
    });
}
